import React, {FC} from 'react'
import {
  EMPLOYMENT_TYPE_OPTIONS,
  IPublicJobModel,
  optionLabel,
  SECTOR_OPTIONS,
  WORK_TYPE_OPTIONS,
} from '../../hr/job/JobModel'

type Props = {
  job: IPublicJobModel
  /** Kartta sektör başlığın yanında gösterildiği için ayrıca basılmaz */
  showSector?: boolean
  showLocations?: boolean
}

/** İstihdam tipi, çalışma şekli, sektör ve lokasyon etiketleri */
export const JobMeta: FC<Props> = ({job, showSector = true, showLocations = true}) => (
  <div className='pc-meta'>
    <span className='pc-meta-item'>
      <i className='bi bi-clock'></i>
      {optionLabel(EMPLOYMENT_TYPE_OPTIONS, job.employmentType)}
    </span>
    <span className='pc-meta-item'>
      <i className='bi bi-building'></i>
      {optionLabel(WORK_TYPE_OPTIONS, job.workType)}
    </span>
    {showSector && job.sector && (
      <span className='pc-pill pc-pill--accent'>{optionLabel(SECTOR_OPTIONS, job.sector)}</span>
    )}
    {showLocations && <JobLocations job={job} />}
  </div>
)

export const JobLocations: FC<{job: IPublicJobModel}> = ({job}) => (
  <>
    {job.locationList.map((location) => (
      <span key={location.id || `${location.province}-${location.district}`} className='pc-pill'>
        <i className='bi bi-geo-alt'></i>
        {location.district ? `${location.district}, ${location.province}` : location.province}
      </span>
    ))}
  </>
)
